import { useMutation } from "react-query";
import * as config from "../../../app.config";
import { setHeaders } from "../../../utils/basic";
import { USER_MESSAGE } from "../../../actions/User";
import axios from "axios";


const mutatePostReplicateAnalysisData = async ({ apiData }) => {
    let apiUrl = `${config.ENDPOINTS["datalake"]}/qc/analysis/replicate_analysis`;
    const response = await axios.post(apiUrl, apiData,
        {
            headers: setHeaders()
        });
    if (!response?.data) {
        throw new Error('Network response was not ok');
    }
    return response?.data;
};

const useMutateReplicateAnalysis = () => {

    const mutation = useMutation(mutatePostReplicateAnalysisData, {
        mutationKey: 'replicateAnalysis',
        onSuccess: (apiData) => {

        },
        onError: (error) => {
            console.log(error);
        },
    }
    );
    return mutation;

};

export default useMutateReplicateAnalysis;